import React from 'react';
import { createRoot } from 'react-dom/client';
import AboutCards from './components/AboutCards';

const container = document.getElementById('about-cards-root');

if (container) {
  const root = createRoot(container);
  root.render(<AboutCards />);
}
